import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { manualJobEndApi } from '@/api/manualJobEndApi';
import type {
  GenerateManualJobEndRequest,
  ManualJobEndResult,
} from '@/api/types/manualJobEnd.types';

export const manualJobEndKeys = {
  all: ['manualJobEnd'] as const,
  assignments: (staffId: number) => ['manualJobEnd', 'assignments', staffId] as const,
};

export function useManualJobEndAssignments(staffId: number | null) {
  return useQuery({
    queryKey: manualJobEndKeys.assignments(staffId ?? 0),
    queryFn: () => manualJobEndApi.getAssignments(staffId!),
    enabled: !!staffId,
  });
}

export function useGenerateManualJobEnd(staffId: number | null) {
  const queryClient = useQueryClient();

  return useMutation<ManualJobEndResult, unknown, GenerateManualJobEndRequest>({
    mutationFn: (request: GenerateManualJobEndRequest) => manualJobEndApi.generate(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['activeJobEnds'] });
      if (staffId != null) {
        queryClient.invalidateQueries({ queryKey: manualJobEndKeys.assignments(staffId) });
      }
    },
  });
}
